<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/8WzFwB/tc-custom/9781608081363.jpg?1692012984653" alt="This image is the cover for the book Russia in Private"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Russia in Private
      </h1>
      <p class="bookDescription body article font2">
        <p>From the very beginning of Russia's history, discord has been prevalent thanks to the ruinous jealousy of the nobles, the Pecheneg and Tatar invasions, and lost wars (or brutally costly victories, as in 1812 or 1945). Autocratic government with serfdom, famine, and gangsterism have been the Russian lot. Two questions: "Who is to blame?" and "What is to be done?", have plagued life in that one-sixth of the world's land surface since its conception, roughly 988 AD. During ten tours of Russia, between 1961 and 1997 (nearly thirty years in all), Richard Yatzeck was generously included in the political, kitchen table conversations concerning these very questions. Public discussion of such matters has never been safe. Russia in Private is an attempt to plumb the abyss between Russian and Western life, and explain how Russians understand and bear their history.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Richard Yatzeck
      </h2>
      
      <p class="authorDescription body article">In 1961 and 1962, Richard Yatzeck spent a year in Moscow as a graduate student, workin gon his dissertation. Beginning in 1966, he taught courses on 19th and 20th-century Russian literature and Russian literary traditions at Lawrence University in Appleton, Wisconsin. in 1991 and 1997, he directed semester programs for the Associated Colleges of Midwest-Great Lakes College Association in Krasnodar, Russia. An avid outdoorsman, he is also the author of "Hunting the Edges".</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      BQB Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?67e14c08